/**
 * Author: Valeria Sinnati
 *   ╱|、
 * (˚ˎ 。7   Interruttore per stati a due valori (es. piatto disponibile o
 *  |、˜〵    esaurito). Un `role="switch"` e non una checkbox: lo stato è già
 * じしˍ,)ノ  attivo adesso, non una scelta che si conferma dopo.
 *
 * `etichetta` è il nome accessibile e deve dire DI COSA parla, non solo lo
 * stato: in una pagina con trenta piatti sentirsi leggere "disponibile" trenta
 * volte non aiuta nessuno.
 *
 * L'area toccabile arriva a 44px su palmare tramite il riempimento del
 * pulsante, mentre il binario resta piccolo: margini negativi la allargano
 * senza spostare il resto della riga.
 */

export interface ToggleProps {
  attivo: boolean
  onCambia: (attivo: boolean) => void
  etichetta: string
  disabilitato?: boolean
  className?: string
}

export function Toggle({
  attivo,
  onCambia,
  etichetta,
  disabilitato = false,
  className = '',
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={attivo}
      aria-label={etichetta}
      disabled={disabilitato}
      onClick={() => onCambia(!attivo)}
      className={
        `-m-2 inline-flex min-h-11 shrink-0 items-center p-2 transition-opacity ` +
        `disabled:cursor-progress disabled:opacity-50 sm:min-h-0 ${className}`
      }
    >
      <span
        className={
          `inline-flex h-6 w-11 items-center rounded-full border transition-colors ` +
          (attivo ? 'border-transparent bg-accent' : 'border-line bg-panel-3')
        }
      >
        <span
          className={
            `size-4.5 rounded-full transition-transform duration-200 ease-out-quint ` +
            (attivo ? 'translate-x-[1.375rem] bg-on-accent' : 'translate-x-0.5 bg-faint')
          }
        />
      </span>
    </button>
  )
}
